/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ViewAsCodeExchange
 */
export interface ViewAsCodeExchange {
    /**
     * 
     * @type {string}
     * @memberof ViewAsCodeExchange
     */
    code: string;
}

/**
 * Check if a given object implements the ViewAsCodeExchange interface.
 */
export function instanceOfViewAsCodeExchange(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function ViewAsCodeExchangeFromJSON(json: any): ViewAsCodeExchange {
    return ViewAsCodeExchangeFromJSONTyped(json, false);
}

export function ViewAsCodeExchangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViewAsCodeExchange {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function ViewAsCodeExchangeToJSON(value?: ViewAsCodeExchange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}

